import { use } from 'react';

import { OrganisationFormName } from '../../../../../../../domain/enums/organisation-form-name';
import ElectronicClientRecordProviderContext from '../../../providers/contexts/electronic-client-record-context';

interface LinkedRoomItemHook {
  onUnlinkButtonClicked: () => void;
}

const useLinkedRoomItemHook = (): LinkedRoomItemHook => {
  const { form, watchedSelectedRoom } = use(ElectronicClientRecordProviderContext);

  const onUnlinkButtonClicked = (): void => {
    form.setValue(
      OrganisationFormName.ElectronicClientRecordRoom,
      {
        ...watchedSelectedRoom,
        isUnlinked: !watchedSelectedRoom?.isUnlinked,
      },
      {
        shouldDirty: true,
      },
    );
  };

  return {
    onUnlinkButtonClicked,
  };
};

export default useLinkedRoomItemHook;
